export enum UnloadingSupport {
  NoSpecification = "noSpecification",
  Forklift = "forklift",
}

export const mapToUnloadingSupportType = (
  forklift?: boolean,
): UnloadingSupport | undefined => {
  return forklift
    ? UnloadingSupport.Forklift
    : UnloadingSupport.NoSpecification;
};
